import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';


@Injectable({
    providedIn: 'root',
})

export class EncryptionService {
    private KEY = 'JyNrbhmUzQhXRJihm1UhgLef'; // Replace with your actual key
    dataPadder(data: string): string {
        if(data.length % 8 == 0){
            return data;
        } else {
            for(let i =0 ; i< (data.length % 8); ++i){
                data += ' ';
            }
             return data;
        }
    }

    encryptData(data: string): string {
        data = this.dataPadder(data);
        // Generate MD5 hash and truncate to 24 characters
        // const md5Key = CryptoJS.MD5(this.KEY).toString(CryptoJS.enc.Hex).substring(0, 24);
        // // Encrypt using TripleDES
        // const key = CryptoJS.enc.Utf8.parse(md5Key);
        const md5Key = CryptoJS.MD5(this.KEY).toString(CryptoJS.enc.Hex).substring(0, 24);
        const parsedKey = CryptoJS.enc.Utf8.parse(md5Key);
        const encrypted = CryptoJS.TripleDES.encrypt(data, parsedKey, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    }
}
